import {
  Button,
  Input,
  Select,
  notification,
  Row,
  Col,
  Modal,
  Divider,
  Space,
  AutoComplete,
  DatePicker,
  Tag,
  Drawer,
  Slider,
  Switch,
  Tooltip,
  Segmented,
} from "antd";
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../assets/utils/useAuth";
import { usePermissions } from "../../assets/utils/usePermissions";
import useLocalStorage from "../../assets/utils/useLocal";
import lib, { myRequestObj, writeArrayToCSV } from "../../assets/utils/lib";
import { useUnifiedSearch } from "../../hooks/useUnifiedSearch";
import { useUnifiedSearchCatalog } from "../../hooks/useUnifiedSearchCatalog";
import "../../styles/main.scss";
import { uri } from "../../assets/utils/http-request";
import config, { category, policy_type, searchTarget, states } from "../../assets/utils/config";
import {
  CheckOutlined,
  CloseOutlined,
  LoadingOutlined,
  SettingOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  SearchOutlined,
  FilterOutlined,
  ClearOutlined,
  HistoryOutlined,
  StarOutlined,
  ThunderboltOutlined,
  UnorderedListOutlined,
  AppstoreOutlined,
  TableOutlined,
  DownloadOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { BiBuildings } from "react-icons/bi";

import formValidator from "../formvalidation";
import CustomFileUploadModal from "../compoinents/UploadModal.js";
import SearchableTable from "../compoinents/SearchableTable.js";
import { PolicyHolderModal } from "../compoinents/userData.js";
import { ListOfDependent } from "../compoinents/profileUpdate.js";
import { EnroleeBiodataModal } from "../compoinents/enroleeData.js";
import { FacilityData } from "../compoinents/FacilityData.js";
import { toFacilityProviderRecord, getFacilityPlanType, getFacilityTypeName } from "../facilities/facilityUtils";
import FacilityOnboardingModal from "../facilities/FacilityOnboardingModal";
import { SearchResultsGrid, SearchResultsSkeleton } from "./SearchResultCards";
import { SearchResultsTable } from "./SearchResultsTable";
import DashboardSection from "../dashboard/components/DashboardSection";
import { TableSkeleton } from "../dashboard/components/DashboardSkeleton";
import "../dashboard/index.css";
import "./search-dashboard.css";
import FacilitiesExportModal from "../../components/Facilities/FacilitiesExportModal";
import FacilitiesExportsDrawer from "../../components/Facilities/FacilitiesExportsDrawer";
import { canExportFacilities } from "../../components/Facilities/facilityExportHelpers";
import { resolveEnrolleeRoleLabel } from "../compoinents/EnrolleeIdentityStrip";

const { Search } = Input;
const { Option } = Select;

const SearchHook = () => {
  const { user } = useAuth();
  const {
    hasAnyPermission,
    hasAnyPermissionWithLegacy,
    canStayOnModule,
  } = usePermissions();

  // Toolbar create actions. The two used to share one role gate but need different
  // permissions, and the "New facility" block was duplicated for legacy role 4.
  const canCreateClient = hasAnyPermissionWithLegacy(
    ['clients.create', 'clients.manage_all', 'admin.*'],
    [1, 2, 5],
  );
  // Matches the backend guard on POST /v2/admin/facilities exactly
  // (api_v1/public/v2.php:4708 => ['facilities.manage', 'admin.*']).
  const canCreateFacility = hasAnyPermissionWithLegacy(
    ['facilities.manage', 'facilities.create', 'admin.*'],
    [1, 2, 4, 5],
  );
  const navigate = useNavigate();

  const facilityIdForCatalog =
    user?.facility_id ?? user?.facilityId ?? user?.profile?.facility_id ?? null;
  const { selectOptions: searchTypeOptions } = useUnifiedSearchCatalog({
    enabled: !!user,
    facilityId: facilityIdForCatalog,
    fallbackOptions: searchTarget,
  });

  const unifiedSearchHeadless = useUnifiedSearch({ manageLoading: false });

  const [, setError] = React.useState(false);
  const [socialwarn, setSocialWarn] = useState("");
  const [validSocial, setValidSocial] = useState(true);
  const [addedHeads, setAddedHeads] = useState(0);
  const [premiumType, setPremiumType] = useState("Individual");

  const [clientRegistrationData, setClientRegistrationData] = useState({});

  const [loading, setLoading] = useState(false);
  const [loadingCreateUser, setLoadingCreateUser] = useState(false);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [showCreateFacilityModal, setShowCreateFacilityModal] = useState(false);
  const [validatingSocial, setValidatingSocial] = useState(false);
  const [validatedSocial, setValidatedSocial] = useState(false);

  const [_, setClientData] = useState({});
  const [searchParam, setSearchParam] = useLocalStorage(config.key.search);

  useEffect(() => {
    if (!searchTypeOptions?.length || !searchParam?.target) return;
    const ok = searchTypeOptions.some(
      (o) => o.value === searchParam.target && !o.disabled,
    );
    if (ok) return;
    const first = searchTypeOptions.find((o) => !o.disabled);
    if (first) setSearchParam((d) => ({ ...d, target: first.value }));
  }, [searchTypeOptions, searchParam?.target, setSearchParam]);

  const [showBatchUserModal, setShowBatchUserModal] = useState(false);
  const [showBatchEnroleeModal, setShowBatchEnroleeModal] = useState(false);
  const [uploading, setUploading] = useState(false)

  const [tableToRender,] = useState('clients')
  const [searchResult, setSarchResult] = useState({ [tableToRender]: [] });
  /** API `search` metadata; show "Filtered by …" only when non-null (unified search UI guide). */
  const [lastSearchMeta, setLastSearchMeta] = useState(null);

  const [packagePrices, setPackagePrices] = useState({})
  const [packages, setPackages] = useState([]);

  // Modern Search Features
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [searchHistory, setSearchHistory] = useLocalStorage('search-history', []);
  const [savedSearches, setSavedSearches] = useLocalStorage('saved-searches', []);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [quickFilters, setQuickFilters] = useState({
    status: 'all',
    dateRange: null,
    sortBy: 'relevance',
    sortOrder: 'desc'
  });
  const [searchMode, setSearchMode] = useState('instant'); // 'instant' or 'manual'
  const [viewMode, setViewMode] = useLocalStorage('search-view-mode-v2', 'table'); // 'grid' | 'table'
  const [favoriteSearches, setFavoriteSearches] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchDebounceTimer, setSearchDebounceTimer] = useState(null);
  
  // Mobile-specific features
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [filtersCollapsed, setFiltersCollapsed] = useState(true);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [facilityExportOpen, setFacilityExportOpen] = useState(false);
  const [facilityExportsDrawerOpen, setFacilityExportsDrawerOpen] = useState(false);

  // Detail modals open read-only for everyone who may NOT edit; each modal still
  // gates its own writes. Same rule as components/GlobalSearch/GlobalSearchOverlay.jsx.
  const canEdit = () =>
    hasAnyPermissionWithLegacy(
      ['clients.update', 'clients.manage_all', 'admin.*'],
      [1, 2],
    );

  // Modern Search Utilities
  const addToSearchHistory = (query, target) => {
    if (!query.trim()) return;
    
    const historyItem = {
      id: Date.now(),
      query: query.trim(),
      target,
      timestamp: new Date().toISOString(),
      resultCount: searchResult[target]?.length || 0
    };
    
    const updatedHistory = [historyItem, ...searchHistory.filter(item => 
      !(item.query === query.trim() && item.target === target)
    )].slice(0, 10); // Keep only latest 10
    
    setSearchHistory(updatedHistory);
  };

  const saveSearch = (query, target, name = null) => {
    const searchItem = {
      id: Date.now(),
      name: name || `${target}: ${query}`,
      query: query.trim(),
      target,
      filters: quickFilters,
      createdAt: new Date().toISOString()
    };
    
    setSavedSearches([...savedSearches, searchItem]);
    notification.success({
      message: 'Search Saved',
      description: 'You can access this search from your saved searches.',
      placement: 'topRight'
    });
  };

  const generateSearchSuggestions = (query) => {
    if (!query.trim()) {
      setSearchSuggestions([]);
      return;
    }

    // Smart suggestions based on search history and common patterns
    const historySuggestions = searchHistory
      .filter(item => item.query.toLowerCase().includes(query.toLowerCase()))
      .map(item => ({
        value: item.query,
        label: (
          <div className="suggestion-item">
            <HistoryOutlined className="suggestion-icon" />
            <span className="suggestion-text">{item.query}</span>
            <span className="suggestion-meta">{item.target}</span>
          </div>
        )
      }));

    // Common search patterns
    const commonPatterns = [
      `${query}*`,
      `*${query}*`,
      `${query} active`,
      `${query} pending`
    ].map(pattern => ({
      value: pattern,
      label: (
        <div className="suggestion-item">
          <ThunderboltOutlined className="suggestion-icon" />
          <span className="suggestion-text">{pattern}</span>
          <span className="suggestion-meta">smart pattern</span>
        </div>
      )
    }));

    setSearchSuggestions([...historySuggestions, ...commonPatterns].slice(0, 8));
  };

  const performSearch = async (query = searchParam?.search, target = searchParam?.target, skipHistory = false) => {
    if (!target) return;
    const cat = searchTypeOptions.find((o) => o.value === target)?.catalog;
    if (!query?.trim() && !lib.effectiveUnifiedSearchAllowsEmptyQuery(target, cat)) return;

    setIsSearching(true);
    setLoading(true);

    try {
      // Add to history unless it's from history
      if (!skipHistory) {
        addToSearchHistory(query, target);
      }

      // Perform actual search (keeping existing logic)
      await showDetail();
      
    } catch (error) {
      console.error('Search error:', error);
      notification.error({
        message: 'Search Failed',
        description: 'An error occurred while searching. Please try again.',
      });
    } finally {
      setIsSearching(false);
      setLoading(false);
    }
  };

  const handleInstantSearch = (query) => {
    if (searchMode !== 'instant') return;
    
    // Clear previous timer
    if (searchDebounceTimer) {
      clearTimeout(searchDebounceTimer);
    }

    // Set new timer for debounced search
    const timer = setTimeout(() => {
      const t = searchParam?.target;
      const q = query.trim();
      if (!t) return;
      const cat = searchTypeOptions.find((o) => o.value === t)?.catalog;
      if (!lib.effectiveUnifiedSearchAllowsEmptyQuery(t, cat) && !q) return;
      const minLen = lib.effectiveUnifiedSearchMinQueryLength(t, cat);
      if (q && minLen > 0 && q.length < minLen) return;
      performSearch(query, searchParam?.target);
    }, 500);

    setSearchDebounceTimer(timer);
  };

  const clearSearch = () => {
    setSearchParam({ search: '', target: searchParam?.target || 'clients' });
    setSarchResult({ [tableToRender]: [] });
    setSearchSuggestions([]);
  };

  const applyQuickFilter = (filterType, value) => {
    setQuickFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
    
    // Re-trigger search with new filters
    if (searchParam?.search) {
      performSearch(searchParam.search, searchParam.target, true);
    }
  };

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  });// eslint-disable-line react-hooks/exhaustive-deps

  // Mobile detection and responsive handling
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // Auto-collapse filters on mobile
      if (mobile) {
        setFiltersCollapsed(true);
      }
      
      // Close advanced filters drawer when switching to mobile
      if (mobile && showAdvancedFilters) {
        setShowAdvancedFilters(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [showAdvancedFilters]);

  useEffect(() => {
    showDetail();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (showCreateUserModal) {
      myRequestObj('plans').post({})
        .then(data => data?.data)
        .then(data => {
          data?.data?.map(plan => {
            setPackages(d => [...d, { label: plan?.plan_name?.__capitalize(), value: plan?.plan_name?.__lower() }]);
            setPackagePrices(d => (
              {
                ...d,
                [plan?.plan_name?.__lower()]: { individual: plan?.plan_cost, family: plan?.plan_six_cost }
              }
            ));
          })
        });
    }
  }, [showCreateUserModal]);

  const showDetail = async () => {
    setClientData({});
    setSarchResult(d => ({ ...d, [tableToRender]: [] }));
    setLastSearchMeta(null);

    const key = "verify";

    if (!searchParam?.target) {
      notification.warning({
        message: "The query was not understood",
        key,
        placement: "topLeft",
      });
      return;
    }

    const q = (searchParam?.search || "").trim();

    const catEntry = searchTypeOptions.find(
      (o) => o.value === searchParam.target,
    )?.catalog;
    const resource = lib.unifiedSearchTargetToResource(searchParam.target);
    const extra = {};
    if (lib.unifiedSearchRequiresFacilityId(resource) && facilityIdForCatalog) {
      extra.facility_id = Number(facilityIdForCatalog);
    }

    setLoading(true);
    try {
      const out = await unifiedSearchHeadless.execute({
        target: searchParam.target,
        search: q,
        page: 1,
        catalogEntry: catEntry,
        extra,
        omitState: true,
      });

      if (!out.ok) {
        if (out.validation === "empty") {
          notification.warning({
            message: "The query was not understood",
            key,
            placement: "topLeft",
          });
        } else if (typeof out.validation === "string") {
          notification.warning({
            message: out.validation,
            key,
            placement: "topLeft",
          });
        } else if (out.aborted) {
          /* ignore */
        } else if (out.status === 403) {
          notification.error({
            message: "You do not have access to this search.",
            key,
            placement: "topLeft",
          });
        } else {
          notification.error({
            message: out.error || "Search request failed",
            key,
            duration: 2,
            placement: "topLeft",
          });
        }
        return;
      }

      setClientData(out.data);
      setSarchResult((d) => ({ ...d, [searchParam.target]: out.data }));
      setLastSearchMeta(out.body?.search != null ? out.body.search : null);
    } finally {
      setLoading(false);
    }
  };

  const handleOk = async () => {
    if (
      (clientRegistrationData.category === "corporate" ||
        clientRegistrationData.category === "referal") &&
      validSocial === false
    ) {
      notification.error({
        message: "Invalid Assocaition Code",
        placement: "topLeft",
      });
      return;
    }

    if (clientRegistrationData?.premium_type === "family") {
      var additional_heads = 6 + addedHeads - 1;
      var enrolee_size = 6 + addedHeads;
      var policy_cost = clientRegistrationData?.insurance_package
        ? packagePrices[clientRegistrationData?.insurance_package][
        "individual"
        ] *
        6 +
        packagePrices[clientRegistrationData?.insurance_package][
        "individual"
        ] *
        addedHeads
        : packagePrices[clientRegistrationData?.insurance_package]["family"] +
        packagePrices[clientRegistrationData?.insurance_package][
        "individual"
        ] *
        addedHeads;
    } else {
      additional_heads = addedHeads;
      enrolee_size = addedHeads + 1;
      policy_cost =
        packagePrices[clientRegistrationData?.insurance_package]["individual"] +
        packagePrices[clientRegistrationData?.insurance_package]["individual"] *
        addedHeads;
    }

    let builder = formValidator.validateAccountRegistration(
      {
        ...clientRegistrationData,
        additional_heads,
        enrolee_size,
        policy_cost,
      },
      {},
      setError
    );

    setLoadingCreateUser(true);

    let reqData = await lib.registerDash(builder);

    if (reqData.status === "error") {
      notification.error({ message: reqData.msg, placement: "topLeft" });
    }
    if (Number(reqData.data?.error )=== 1) {
      notification.error({
        message: reqData.data.message,
        placement: "topLeft",
      });
    }

    if (Number(reqData.data?.error )=== 0) {
      notification.success({
        message: reqData.data.message,
        placement: "topLeft",
      });
      // setShowCreateUserModal(false);
      setClientRegistrationData({});
    }

    setLoadingCreateUser(false);
  };

  const handleDependent = (e) => {
    setAddedHeads(e);
  };

  const handleFocusOut = async (e) => {
    setValidatingSocial(true);
    let obj = {
      social_no: clientRegistrationData?.social_no,
      mode: clientRegistrationData?.category,
    };

    let reqData = await lib.validatSocial(obj);

    if (reqData?.status === "error") {
      notification.error({ message: reqData.msg, placement: "topLeft" });
    }

    if (Number(reqData?.error) === 1) {
      notification.error({ message: "Invalid code", placement: "topLeft" });
      setSocialWarn("Invalid code");
      setValidSocial(false);
    }

    if (Number(reqData?.error) === 0) {
      notification.success({ message: reqData.message, placement: "topLeft" });
      setValidSocial(true);
      setSocialWarn("");
    }
    setValidatedSocial(true);
    setValidatingSocial(false);
  };

  const uploadToServer = async (endpoint, data, target) => {
    setUploading(true)
    notification.info({
      message: <>
        <p>Bulk upload in progress!!!</p>
        <p><strong>Please do not close or refresh this window</strong></p>
        <>This operation could take a couple of minutes</>
      </>,
      key: "upload",
      icon: <LoadingOutlined />,
      duration: 0,
      placement: "topLeft",
    })
    myRequestObj(endpoint).post(data)
      .then(response => response)
      .then(data => {
        console.log(data);
        if (Number(data?.data?.error) === 0) {
          notification.success({ message: data?.data?.message, key: 'upload' })
          const link = document.createElement("a");

          link.href = uri + '/' + data?.data?.data;
          link.download = `Bulk ${target} Onboarding Report.csv`;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        } else {
          notification.error({ message: data?.data?.message, key: 'upload' })
        }
      }).catch(error => {
        console.error('Error uploading file(s)', error);
        notification.info({
          message: <>
            <p>Bulk upload failed</p>
            <p>{error?.message || error?.msg}</p>
          </>,
          key: "upload",
          icon: <LoadingOutlined />,
          duration: 0,
          placement: "topLeft",
        })
      }).finally(() => {
        setUploading(false)
        setTimeout(() => {
          notification.destroy('upload')
        }, 2000)
      });
  }

  const handleBatchUploadUsers = async (files) => {
    const formData = new FormData();
    formData.append('file', files[0]);
    await uploadToServer('batchUsers', formData, 'Policy')
  }

  const saveBatchEnrollee = async (files) => {
    const formData = new FormData();
    formData.append('file', files[0]);
    await uploadToServer('batchEnrollees', formData, 'Enrollee')
  }

  const clientsTable = [
    "email", "phone", "name", "category", "social_no", "insurance_package", "additional_heads",
    "premium_type", "state", "city"
  ];

  const enrolleeTable = [
    "first_name", "surname", "middle_name", "date_of_birth",
    "relationship", "title", "gender", "religion", "contact_address",
    "phone", "email", "lga", "state", "marital_status", "existing_medical_condition",
    "previous_medical_condition", "policy_no", "insurance_no", "financier_id",
    "primary_health_facility", "secondary_health_facility", "role",
  ]

  const orgTable = [
    "org_id", "org_name", "org_social_no", "org_code", "org_email", "org_address",
    "org_city", "org_state", "org_joined_date", "org_renew_date", "org_expiry_date", "org_status"
  ];

  const constableItems = [
    "id", "item_code", "item_brand", "item_name", "item_dosage", "item_strength",
    "item_presentation", "category_id", "item_status", "category_name"
  ];

  const mappings = {
    clients: [
      {
        title: 'Policy Name | No. | Email',
        dataIndex: 'name',
        key: 'name',
        render: (__, record) => <><strong>{__?.toUpperCase()}</strong> <br></br><strong>{record?.policy_no}</strong><br></br><strong>{record?.email}</strong></>
      },
      {
        title: 'Package',
        dataIndex: 'premium_type',
        key: 'premium_type',
        render: (__, record) => <>
          {record?.insurance_package?.toUpperCase()}<br></br>
          {__?.toUpperCase()}
        </>
      },
      {
        title: 'Premium',
        dataIndex: 'category',
        key: 'category',
        render: (__, record) => <>
          {record?.category}<br></br>
          {record?.category === 'corporate' && <>{record?.social_no}</>}<br></br>
        </>
      },
      {
        title: 'No. Enrollees',
        dataIndex: 'enrolee_size',
        key: 'enrolee_size',
        render: (__, record) => <>{record?.active_enrollees} of {__}</>
      },
      {
        title: 'Date (Joined | Validity)',
        dataIndex: 'date',
        key: 'date',
        render: (__, record) => <>{(new Date(__)).toDateString()} <br></br>{(new Date(record?.expiry_date)).toDateString()}</>
      },
      {
        title: 'Status | Action',
        key: 'status',
        render: (__, record) => <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>{record.status ? <CheckOutlined style={{ color: 'blue' }} /> : <CloseOutlined style={{ color: 'red' }} />}</Space>
          <Divider type="vertical" style={{ border: '1px solid black' }} />
          <Space>
            <Button type="link" icon={<SettingOutlined />} onClick={() => rowSetting(record, searchParam?.target)} />
            <Button type="link" icon={<UsergroupAddOutlined />} onClick={() => rowSetting(record, 'client_enrollees')} />
          </Space>
        </div>,
      },
    ],
    corporations: [
      {
        title: "Name",
        key: 'org_name',
        dataIndex: 'org_name',
        render: (_, record) => <>
          <div><strong>{_}</strong></div>
          <div><strong>Code</strong>: {record?.org_social_no || record?.code}</div>
        </>
      },
      {
        key: 'org_address',
        dataIndex: 'org_address',
        title: "Contact Address",
        render: (_, record) => <>
          <div><strong>{_}</strong></div>
          <div>{record?.org_city} {record?.org_state}</div>
          <div><strong>Email</strong>: {record?.org_email}</div>
        </>
      },
      {
        key: 'org_expiry_date',
        dataIndex: 'org_expiry_date',
        title: "Dates",
        render: (_, record) => <>
          <div><strong>Onboarded</strong>: {record?.org_joined_date ? (new Date(record?.org_joined_date)).toDateString() : null}</div>
          <div><strong>Last Renewal</strong>: {(new Date(record?.org_renew_date)).toDateString()}</div>
          <div><strong>Next Renewal</strong>: {(new Date(record?.org_expiry_date)).toDateString()}</div>
        </>
      },
      {
        key: 'org_status',
        title: <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>Status</Space>
        </div>,
        dataIndex: 'org_status',
        render: (_, record) => <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>{_ ? <CheckOutlined style={{ color: 'blue' }} /> : <CloseOutlined style={{ color: 'red' }} />}</Space>
        </div>
      },
    ],
    facilities: [
      {
        key: 'facility_name',
        title: "Facility Name | Phone | Email",
        dataIndex: 'facility_name',
        render: (_, record) => <>
          <strong>{_}</strong><br></br>
          <strong>{record?.facility_phone}</strong><br></br>
          <strong>{record?.facility_email}</strong>
        </>
      },
      {
        key: 'facility_plan_type',
        title: "Facility Plan Type",
        dataIndex: 'facility_plan_type',
        render: (_, record) => {
          const facilityType = getFacilityTypeName(record);
          const planType = getFacilityPlanType(record);
          return <>
          <strong>{facilityType ? facilityType.toUpperCase() : '—'}</strong><br></br>
          <strong>{planType ? planType.toUpperCase() : '—'}</strong>
        </>;
        }
      },
      {
        key: 'facility_address',
        title: "Facility Address",
        dataIndex: 'facility_address',
        render: (_, record) => <>
          {_}<br></br>
          <strong>{record?.facility_city} | {record?.facility_state}</strong><br></br>
          {record?.facility_website && <Button type="link">{record?.facility_website}</Button>}
        </>
      },
      {
        key: 'facility_status',
        title: <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>Status</Space>
          <Divider type="vertical" style={{ border: '1px solid black' }} />
          <Space>Action</Space>
        </div>,
        dataIndex: 'facility_status',
        render: (_, record) => <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>{_ ? <CheckOutlined style={{ color: 'blue' }} /> : <CloseOutlined style={{ color: 'red' }} />}</Space>
          <Divider type="vertical" style={{ border: '1px solid black' }} />
          <Space>
            <Button type="link" icon={<SettingOutlined />} onClick={() => rowSetting(record, searchParam?.target)} />
          </Space>
        </div>
      },
    ],
    enrollees: [
      {
        title: 'Name',
        key: 'title',
        render: (_, record) => <div>
          <strong>{record?.title ? record?.title + ". " : ''}{record?.first_name} {record?.middle_name ? record?.middle_name + ' ' : ''}{record?.surname}</strong>
          <div><strong>Role:</strong> {record?.role}</div>
          <div><strong>Gender:</strong> {record?.gender}</div>
        </div>,
      },
      {
        title: 'Contact Information',
        key: 'email',
        render: (_, record) => (
          <>
            <div>{record?.phone}</div>
            <div>{record?.email}</div>
            <div>{record?.contact_address}</div>
            <div>{record?.lga}, {record?.state}</div>
          </>
        ),
      },
      {
        title: 'Medical Information',
        key: 'existing_medical_condition',
        render: (_, record) => (
          <>
            <div><strong>Existing:</strong> {record?.existing_medical_condition || 'N/A'}</div>
            <div><strong>Previous:</strong> {record?.previous_medical_condition || 'N/A'}</div>
          </>
        ),
      },
      {
        title: 'Insurance Details',
        key: 'insurance_no',
        render: (_, record) => (
          <>
            <div><strong>Policy No:</strong> {record?.policy_no}</div>
            <div><strong>Insurance No:</strong> {record?.insurance_no}</div>
          </>
        ),
      },
      {
        title: 'Facilities',
        key: 'primary_health_facility',
        render: (_, record) => (
          <>
            <div><strong>Primary:</strong> {record?.primary_health_facility}</div>
            <div><strong>Secondary:</strong> {record?.secondary_health_facility}</div>
          </>
        ),
      },
      {
        title: 'Other Details',
        key: 'relationship',
        render: (_, record) => (
          <>
            {record?.role === 'principal' ? null : <div><strong>Relationship:</strong> {(resolveEnrolleeRoleLabel(record) || '').replace(/^Dependent · /, '') || record?.relationship}</div>}
            <div><strong>Religion:</strong> {record?.religion}</div>
            <div><strong>Date of Birth:</strong> {(new Date(record?.date_of_birth)).toDateString()}</div>
            <div><strong>Marital Status:</strong> {record?.marital_status}</div>
          </>
        ),
      },
      {
        key: 'status',
        title: <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>Status</Space>
          <Divider type="vertical" style={{ border: '1px solid black' }} />
          <Space>Action</Space>
        </div>,
        dataIndex: 'status',
        render: (_, record) => <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>{_ ? <CheckOutlined style={{ color: 'blue' }} /> : <CloseOutlined style={{ color: 'red' }} />}</Space>
          <Divider type="vertical" style={{ border: '1px solid black' }} />
          <Space>
            <Button type="link" icon={<SettingOutlined />} onClick={() => rowSetting(record, searchParam?.target)} />
          </Space>
        </div>
      },
    ],
    constableItems: [
      {
        title: "Item",
        key: "item_code",
        render: (___, record) => <div>
          Name: <strong>{record?.item_name}</strong><br></br>
          Code: <strong>{record?.item_code}</strong><br></br>
          {Number(record?.category_id) === 1 && <>Brand: <strong>{record?.item_brand}</strong><br></br></>}
        </div>,
        width: '40%'
      },
      {
        title: "Item Presentation",
        key: "item_presentation",
        render: (___, record) => <div>
          Category: <strong>{record?.category_name}</strong><br></br>
          {Number(record?.category) === 1 && <>
            Dosage: <strong>{record?.item_dosage}</strong><br></br>
            Presentation: <strong>{record?.item_presentation}</strong>
          </>}
        </div>
      },
      {
        title: "Data Added",
        key: "item_date",
        render: (___, record) => <strong>{record?.item_date ? (new Date(record?.item_date)).toDateString() : 'N/A'}</strong>
      },
      {
        title: "Status",
        key: "item_status",
        render: (___, record) => (Boolean(record?.item_status) ? <strong>Available</strong> : <strong>Not Available</strong>)
      }
    ]
  };

  // Use the mappings directly for table columns
  const columns = mappings[searchParam?.target || tableToRender];

  const [showClient, setShowClient] = useState(false);
  const [showEnrollee, setShowEnrollee] = useState(false);
  const [openEncounterCodes, setOpenEncounterCodes] = useState(false);
  const [showClientEnrollee, setShowClientEnrollee] = useState(false);
  const [showFacility, setShowFacility] = useState(false);
  const [rowData, setRowData] = useState({});

  // Picks WHICH facility UI opens (full /facilities/:id page vs the lighter modal), not
  // which records come back — the search API filters those server-side. canStayOnModule
  // keeps the legacy ids as the empty-map fallback only.
  const canOpenFacilityDetail = canStayOnModule("facilities", [1, 3, 4, 5]);

  const rowSetting = async (record, actionTarget = null) => {
    const t = actionTarget ?? searchParam?.target;
    if (t === "pa" || t === "claims" || t === "checkins") {
      lib.unifiedSearchOpenTarget(navigate, t, record);
      return;
    }
    setRowData(toFacilityProviderRecord(record));
    switch (t) {
      case "corporations":
        return;
      case "clients":
        setShowClient(true);
        break;
      case "enrollees":
        setOpenEncounterCodes(false);
        setShowEnrollee(true);
        break;
      case "enrollee_encounter_codes":
        setOpenEncounterCodes(true);
        setShowEnrollee(true);
        break;
      case "client_enrollees":
        setShowClientEnrollee(true);
        break;
      case "facilities": {
        const id = record?.facility_id ?? record?.id;
        if (id && canOpenFacilityDetail) {
          navigate(`/facilities/${id}`, { state: record });
        } else {
          setShowFacility(true);
        }
        break;
      }
      default:
        return;
    }
  };

  const handleCancelEnrollees = () => {
    setShowEnrollee(false);
    setOpenEncounterCodes(false);
  }

  const handleCancelFacilities = () => {
    setShowFacility(!showFacility);
  }

  const handleCancelClientEnrollees = () => {
    setShowClientEnrollee(!showClientEnrollee)
  }

  const activeTargetOption = searchTypeOptions.find((o) => o.value === searchParam?.target);
  const activeTargetLabel = activeTargetOption?.label || searchParam?.target || 'results';
  const resultRows = searchResult[searchParam?.target] || [];
  const resultCount = resultRows.length;
  const showFacilityExport =
    searchParam?.target === "facilities" && canExportFacilities(user, hasAnyPermission);
  const canViewFacilityExports = canExportFacilities(user, hasAnyPermission);
  const facilityExportRowEstimate =
    lastSearchMeta?.results_count != null && !Number.isNaN(Number(lastSearchMeta.results_count))
      ? Number(lastSearchMeta.results_count)
      : null;
  const canRunSearch =
    Boolean(searchParam?.search?.trim()) ||
    lib.effectiveUnifiedSearchAllowsEmptyQuery(
      searchParam?.target,
      activeTargetOption?.catalog,
    );

  return (
    <div className="search-dashboard">
      <div className="dashboard-page-stack">
        <header className="dash-masthead">
          <div className="dash-masthead__lead">
            <h1 className="dash-masthead__title">Search &amp; Verify</h1>
            <p className="dash-masthead__meta">
              <span>{searchMode === 'instant' ? 'Instant search' : 'Manual search'}</span>
              {resultCount > 0 ? (
                <>
                  <span className="dash-masthead__sep">·</span>
                  <span>{resultCount} {activeTargetLabel.toLowerCase()} found</span>
                </>
              ) : null}
            </p>
          </div>
          <div className="dash-masthead__actions">
            <div className="search-mode-inline">
              <Switch
                checked={searchMode === 'instant'}
                onChange={(checked) => setSearchMode(checked ? 'instant' : 'manual')}
                checkedChildren={<ThunderboltOutlined />}
                unCheckedChildren="Manual"
                size="small"
              />
            </div>
            {searchHistory.length > 0 ? (
              <Tooltip title="Search history">
                <button
                  type="button"
                  className="dash-icon-btn"
                  onClick={() => setShowAdvancedFilters(true)}
                  aria-label="Search history"
                >
                  <HistoryOutlined />
                </button>
              </Tooltip>
            ) : null}
            <Tooltip title="Advanced filters & history">
              <button
                type="button"
                className={`dash-icon-btn ${showAdvancedFilters ? 'is-active' : ''}`}
                onClick={() => setShowAdvancedFilters(true)}
                aria-label="Advanced filters"
              >
                <FilterOutlined />
                {Object.values(quickFilters).some((v) => v !== 'all' && v !== 'relevance' && v !== 'desc' && v !== null) ? (
                  <span className="dash-icon-btn__dot" />
                ) : null}
              </button>
            </Tooltip>
            {searchParam?.search ? (
              <button type="button" className="dash-icon-btn" onClick={clearSearch} aria-label="Clear search">
                <ClearOutlined />
              </button>
            ) : null}
            {canViewFacilityExports ? (
              <>
                <Button
                  type="default"
                  size="small"
                  icon={<ExportOutlined />}
                  onClick={() => setFacilityExportsDrawerOpen(true)}
                >
                  My exports
                </Button>
                {showFacilityExport ? (
                  <Button
                    type="primary"
                    size="small"
                    icon={<DownloadOutlined />}
                    onClick={() => setFacilityExportOpen(true)}
                  >
                    Export facilities
                  </Button>
                ) : null}
              </>
            ) : null}
            {canCreateClient ? (
              <Button type="default" size="small" icon={<UserAddOutlined />} onClick={() => setShowCreateUserModal(true)}>
                New client
              </Button>
            ) : null}
            {canCreateFacility ? (
              <Button type="default" size="small" icon={<BiBuildings />} onClick={() => setShowCreateFacilityModal(true)}>
                New facility
              </Button>
            ) : null}
          </div>
        </header>

        <div className="dash-filters search-dash-panel">
          <div className="search-input-row">
            <div className="search-type-col">
              <span className="search-field-label">Search type</span>
              <Select
                value={searchParam?.target}
                onChange={(e) => setSearchParam((d) => ({ ...d, target: e }))}
                style={{ width: '100%' }}
                options={searchTypeOptions}
                size="large"
              />
            </div>
            <div className="search-query-col">
              <span className="search-field-label">Query</span>
              <div className="search-input-group">
                <AutoComplete
                  value={searchParam?.search}
                  options={searchSuggestions}
                  onSelect={(value) => {
                    setSearchParam((d) => ({ ...d, search: value }));
                    if (searchMode === 'instant') {
                      performSearch(value, searchParam?.target);
                    }
                  }}
                  onSearch={generateSearchSuggestions}
                  className="search-autocomplete"
                >
                  <Input
                    placeholder="Name, policy no, insurance no, facility…"
                    value={searchParam?.search}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchParam((d) => ({ ...d, search: value }));
                      generateSearchSuggestions(value);
                      if (searchMode === 'instant') {
                        handleInstantSearch(value);
                      }
                    }}
                    onPressEnter={() => performSearch(searchParam?.search, searchParam?.target)}
                    allowClear
                    size="large"
                    suffix={
                      searchParam?.search ? (
                        <div className="search-input-actions">
                          <Tooltip title="Save search">
                            <Button
                              type="text"
                              size="small"
                              icon={<StarOutlined />}
                              onClick={() => saveSearch(searchParam.search, searchParam.target)}
                            />
                          </Tooltip>
                        </div>
                      ) : null
                    }
                  />
                </AutoComplete>
                <Button
                  type="primary"
                  size="large"
                  icon={<SearchOutlined />}
                  onClick={() => performSearch(searchParam?.search, searchParam?.target)}
                  loading={isSearching}
                  disabled={isSearching || !canRunSearch}
                  className="dash-masthead__refresh"
                >
                  Search
                </Button>
              </div>
            </div>
          </div>
        </div>

        <DashboardSection
          id="search-results"
          icon={<UnorderedListOutlined />}
          title="Results"
          subtitle={
            lastSearchMeta?.query
              ? `Filtered by "${lastSearchMeta.query}"`
              : `Search ${activeTargetLabel.toLowerCase()}`
          }
          collapsible={false}
          variant="content"
        >
          {!loading && (searchParam?.target || searchParam?.search) ? (
            <div className="search-results-header">
              <div>
                <h3 className="search-results-header__title">
                  {resultCount > 0
                    ? `${resultCount} ${activeTargetLabel.toLowerCase()} found`
                    : searchParam?.search
                      ? `No ${activeTargetLabel.toLowerCase()} found`
                      : `Search ${activeTargetLabel.toLowerCase()}`}
                </h3>
                {lastSearchMeta != null &&
                  typeof lastSearchMeta === 'object' &&
                  lastSearchMeta.query != null &&
                  String(lastSearchMeta.query).length > 0 ? (
                  <p className="search-results-header__subtitle">
                    Filtered by &quot;{lastSearchMeta.query}&quot;
                    {lastSearchMeta.results_count != null && ` · ${lastSearchMeta.results_count} total`}
                  </p>
                ) : null}
              </div>
              {(resultCount > 0 || searchParam?.search) ? (
                <Space wrap>
                  {showFacilityExport ? (
                    <Button
                      size="small"
                      icon={<DownloadOutlined />}
                      onClick={() => setFacilityExportOpen(true)}
                    >
                      Export CSV
                    </Button>
                  ) : null}
                  <Segmented
                    className="search-view-toggle"
                    size="small"
                    value={viewMode}
                    onChange={setViewMode}
                    options={[
                      { label: 'Cards', value: 'grid', icon: <AppstoreOutlined /> },
                      { label: 'Table', value: 'table', icon: <TableOutlined /> },
                    ]}
                  />
                </Space>
              ) : null}
            </div>
          ) : null}

          {loading ? (
            viewMode === 'table' ? (
              <TableSkeleton rows={8} columns={6} />
            ) : (
              <SearchResultsSkeleton count={6} />
            )
          ) : resultCount > 0 ? (
            viewMode === 'table' ? (
              <SearchResultsTable
                listTarget={searchParam?.target}
                results={resultRows}
                onRowAction={(record, action) => rowSetting(record, action)}
              />
            ) : (
              <SearchResultsGrid
                listTarget={searchParam?.target}
                results={resultRows}
                onRowAction={(record, action) => rowSetting(record, action)}
              />
            )
          ) : searchParam?.search ? (
            <div className="search-empty">
              <div className="search-empty__icon">🔍</div>
              <p className="search-empty__title">No results found</p>
              <p className="search-empty__subtitle">Try a different query or search type</p>
              <Button size="small" onClick={clearSearch} style={{ marginTop: 12 }}>
                Clear search
              </Button>
            </div>
          ) : (
            <div className="search-empty">
              <div className="search-empty__icon">🔍</div>
              <p className="search-empty__title">Start searching</p>
              <p className="search-empty__subtitle">
                Choose a type and enter a query{searchMode === 'instant' ? ' — results update as you type' : ''}
              </p>
            </div>
          )}
        </DashboardSection>
      </div>

      {/* Clients Account Creation Modal */}
      <Modal
        title={
          <Row>
            <Col>Create Policy Account</Col>
          </Row>
        }
        centered
        open={showCreateUserModal && !showCreateFacilityModal}
        onOk={() => { }}
        onCancel={() => setShowCreateUserModal(false)}
        footer={
          user ? (
            <>
              {
                canCreateClient && <Button disabled={loadingCreateUser} onClick={handleOk}>
                  {loadingCreateUser ? <LoadingOutlined /> : <>Create Account</>}
                </Button>
              }
              <Button
                type="dashed"
                disabled={loadingCreateUser}
                danger
                onClick={() => setShowCreateUserModal(false)}
              >
                Close
              </Button>
            </>) : null
        }
        width={800}
        destroyOnClose
      >
        <Row>
          <Col span={24}>
            <Row gutter={[16, 8]}>
              <Col span={24}>
                <Row>
                  <Col span={8}>Insurance Package:</Col>
                  <Col span={16}>
                    <Select
                      disabled={loadingCreateUser}
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          insurance_package: e,
                        }))
                      }
                      value={clientRegistrationData?.insurance_package}
                      style={{ width: "100%", marginRight: "10px" }}
                      options={packages}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Policy Type: </Col>
                  <Col span={16}>
                    <Select
                      disabled={loadingCreateUser}
                      onChange={(e) => {
                        setPremiumType(e);
                        setClientRegistrationData((d) => ({
                          ...d,
                          premium_type: e,
                        }));
                      }}
                      value={
                        clientRegistrationData?.premium_type || premiumType
                      }
                      style={{ width: "100%", marginRight: "10px" }}
                      options={policy_type}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Plan Category: </Col>
                  <Col span={16}>
                    <Select
                      disabled={loadingCreateUser}
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          category: e,
                        }))
                      }
                      value={clientRegistrationData?.category}
                      style={{ width: "100%", marginRight: "10px" }}
                      options={category}
                    />
                  </Col>
                </Row>
                {clientRegistrationData.category === "corporate" ||
                  clientRegistrationData.category === "referal" ? (
                  clientRegistrationData.category === "corporate" ? (
                    <Row>
                      <Col span={8}>Association Code:</Col>
                      <Col span={16}>
                        <Input
                          disabled={loadingCreateUser}
                          suffix={
                            !validSocial && validatedSocial ? (
                              <CloseOutlined style={{ color: "red" }} />
                            ) : validatingSocial ? (
                              <LoadingOutlined style={{ color: "blue" }} />
                            ) : validSocial && validatedSocial ? (
                              <CheckOutlined style={{ color: "green" }} />
                            ) : null
                          }
                          onBlur={handleFocusOut}
                          onChange={(e) =>
                            setClientRegistrationData((d) => ({
                              ...d,
                              social_no: e.target.value,
                            }))
                          }
                          value={clientRegistrationData?.social_no}
                          placeholder="23SWIWQQ"
                          style={{ width: "100%", marginRight: "10px" }}
                        />
                        <span>
                          {clientRegistrationData.category === "corporate" &&
                            !validSocial ? (
                            <>{socialwarn}</>
                          ) : null}
                        </span>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col span={8}>Referal Code:</Col>
                      <Col span={16}>
                        <Input
                          disabled={loadingCreateUser}
                          suffix={
                            !validSocial && validatedSocial ? (
                              <CloseOutlined color="red" />
                            ) : validatingSocial ? (
                              <LoadingOutlined color="blue" />
                            ) : !validSocial && validatedSocial ? (
                              <CheckOutlined color="green" />
                            ) : null
                          }
                          onBlur={handleFocusOut}
                          onChange={(e) =>
                            setClientRegistrationData((d) => ({
                              ...d,
                              social_no: e.target.value,
                            }))
                          }
                          value={clientRegistrationData?.social_no}
                          placeholder="23SWIWQQ"
                          style={{ width: "100%", marginRight: "10px" }}
                        />
                        <span>
                          {clientRegistrationData.category === "referal" &&
                            !validSocial ? (
                            <>{socialwarn}</>
                          ) : null}
                        </span>
                      </Col>
                    </Row>
                  )
                ) : null}
                <Row>
                  <Col span={8}>Full Name:</Col>
                  <Col span={16}>
                    <Input
                      disabled={loadingCreateUser}
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          name: e.target.value,
                        }))
                      }
                      autoFocus
                      value={clientRegistrationData?.name}
                      placeholder="Musa Umar"
                      style={{ width: "100%", marginRight: "10px" }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Additional Dependents:</Col>
                  <Col span={16}>
                    <Select
                      disabled={loadingCreateUser}
                      style={{ width: "100%", marginRight: "10px" }}
                      onChange={handleDependent}
                      value={addedHeads}
                    >
                      <Option value={0}>0</Option>
                      <Option value={1}>1</Option>
                      <Option value={2}>2</Option>
                      <Option value={3}>3</Option>
                      <Option value={4}>4</Option>
                      <Option value={5}>5</Option>
                      <Option value={6}>6</Option>
                      <Option value={7}>7</Option>
                      <Option value={8}>8</Option>
                      <Option value={9}>9</Option>
                      <Option value={10}>10</Option>
                    </Select>
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "bolder",
                        color: "skyblue",
                        lineHeight: "1px",
                      }}
                    >
                      Use this if ther are additional enrollees apart from the
                      provisonal enrollee size: Family = 6 Enrollees; Individual
                      = 1 Enrollee
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>State of Residence: </Col>
                  <Col span={16}>
                    <Select
                      disabled={loadingCreateUser}
                      style={{ width: "100%", marginRight: "10px" }}
                      onChange={(e) => {
                        setClientRegistrationData((d) => ({ ...d, state: e }));
                      }}
                      value={clientRegistrationData?.state}
                      options={states}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>City of Residence: </Col>
                  <Col span={16}>
                    <Input
                      disabled={loadingCreateUser}
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          city: e.target.value,
                        }))
                      }
                      value={clientRegistrationData?.city}
                      placeholder="Ogidilu"
                      style={{ width: "100%", marginRight: "10px" }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Email:</Col>
                  <Col span={16}>
                    <Input
                      disabled={loadingCreateUser}
                      type="email"
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          email: e.target.value,
                        }))
                      }
                      value={clientRegistrationData?.email}
                      placeholder="example@gmail.com"
                      style={{ width: "100%", marginRight: "10px" }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Confirm Email:</Col>
                  <Col span={16}>
                    <Input
                      disabled={loadingCreateUser}
                      type="email"
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          confirm_email: e.target.value,
                        }))
                      }
                      value={clientRegistrationData?.confirm_email}
                      placeholder="example@gmail.com"
                      style={{ width: "100%", marginRight: "10px" }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Phone Number:</Col>
                  <Col span={16}>
                    <Input
                      disabled={loadingCreateUser}
                      type="phone"
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          phone: e.target.value,
                        }))
                      }
                      value={clientRegistrationData?.phone}
                      placeholder="0801 234 5678"
                      style={{ width: "100%", marginRight: "10px" }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Confirm Phone Number</Col>
                  <Col span={16}>
                    <Input
                      disabled={loadingCreateUser}
                      type="phone"
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          confirm_phone: e.target.value,
                        }))
                      }
                      value={clientRegistrationData?.confirm_phone}
                      placeholder="0801 234 5678"
                      style={{ width: "100%", marginRight: "10px" }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Password:</Col>
                  <Col span={16}>
                    <Input.Password
                      disabled={loadingCreateUser}
                      placeholder="*********"
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          password: e.target.value,
                        }))
                      }
                      value={clientRegistrationData?.password}
                      style={{ width: "100%", marginRight: "10px" }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>Confirm Password:</Col>
                  <Col span={16}>
                    <Input.Password
                      disabled={loadingCreateUser}
                      onChange={(e) =>
                        setClientRegistrationData((d) => ({
                          ...d,
                          confirm_password: e.target.value,
                        }))
                      }
                      value={clientRegistrationData?.confirm_password}
                      placeholder="*********"
                      style={{ width: "100%", marginRight: "10px" }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>

      <FacilityOnboardingModal
        open={showCreateFacilityModal && !showCreateUserModal}
        onClose={() => setShowCreateFacilityModal(false)}
        onSuccess={() => setShowCreateFacilityModal(false)}
        user={user}
      />

      <CustomFileUploadModal
        visible={showBatchUserModal}
        onOk={handleBatchUploadUsers} loading={uploading}
        onCancel={() => { setShowBatchUserModal(false); setUploading(false) }}
        name={'Bulk User Onboarding'} showDownload={true} id={'upload_batch_user'}
        downloadHandler={() => writeArrayToCSV(clientsTable, 'policy_registration_dat_format.csv', '|')}
      />

      <CustomFileUploadModal
        visible={showBatchEnroleeModal}
        onOk={saveBatchEnrollee}
        onCancel={() => { setShowBatchEnroleeModal(false); setUploading(false) }} loading={uploading}
        name={'Bulk Dependents Onboarding'} showDownload={true} id={'upload_batch_dependents'}
        downloadHandler={() => writeArrayToCSV(enrolleeTable, 'enrollees_registration_dat_format.csv', '|')}
      />

      {showClient && (
        <PolicyHolderModal
          display={showClient}
          data={rowData}
          action={showDetail}
          showAllActions={true}
          onclose={() => setShowClient(false)}
          viewOnly={!canEdit()}
        />
      )}

      {(showClientEnrollee) ?
        <ListOfDependent
          dependentList={[]}
          policy={rowData}
          // command={() => enrolleeListCommand(rowData)}
          showModal={showClientEnrollee}
          closeModal={handleCancelClientEnrollees}
          viewOnly={!canEdit()}
        /> : null
      }

      {(showEnrollee) && (
        <EnroleeBiodataModal
          data={rowData}
          display={showEnrollee}
          action={handleCancelEnrollees}
          command={showDetail}
          source={1}
          viewOnly={!canEdit()}
          openEncounterCodes={openEncounterCodes}
          onEncounterCodesClose={() => setOpenEncounterCodes(false)}
        />
      )}

      {(showFacility) && <FacilityData data={rowData} display={showFacility} action={handleCancelFacilities} command={showDetail} source={1} viewOnly={!canEdit()} />}

      {/* Mobile-Responsive Advanced Filters Drawer */}
      <Drawer
        title={
          <div className="drawer-header">
            <FilterOutlined />
            <span>Advanced Search & History</span>
          </div>
        }
        placement={isMobile ? "bottom" : "right"}
        width={isMobile ? undefined : 400}
        height={isMobile ? "85%" : undefined}
        open={showAdvancedFilters}
        onClose={() => setShowAdvancedFilters(false)}
        extra={
          <Button type="text" onClick={() => setShowAdvancedFilters(false)}>
            <CloseOutlined />
          </Button>
        }
        style={{
          zIndex: 1000
        }}
        bodyStyle={{
          padding: isMobile ? '16px 12px' : '24px'
        }}
      >
        <div className="advanced-filters-content">
          {/* Search History Section */}
          {searchHistory.length > 0 && (
            <div className="filter-section">
              <h4 className="section-title">
                <HistoryOutlined /> Recent Searches
              </h4>
              <div className="search-history-list">
                {searchHistory.map(item => (
                  <div key={item.id} className="history-item">
                    <div className="history-main">
                      <Button
                        type="text"
                        onClick={() => {
                          setSearchParam({ search: item.query, target: item.target });
                          performSearch(item.query, item.target, true);
                          setShowAdvancedFilters(false);
                        }}
                        className="history-query"
                      >
                        {item.query}
                      </Button>
                      <Tag size="small">{item.target}</Tag>
                    </div>
                    <div className="history-meta">
                      <span className="history-date">
                        {new Date(item.timestamp).toLocaleDateString()}
                      </span>
                      <span className="history-results">
                        {item.resultCount} results
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              <Button 
                type="text" 
                size="small" 
                onClick={() => setSearchHistory([])}
                className="clear-history-btn"
              >
                Clear History
              </Button>
            </div>
          )}

          {/* Saved Searches Section */}
          {savedSearches.length > 0 && (
            <div className="filter-section">
              <h4 className="section-title">
                <StarOutlined /> Saved Searches
              </h4>
              <div className="saved-searches-list">
                {savedSearches.map(item => (
                  <div key={item.id} className="saved-item">
                    <div className="saved-main">
                      <Button
                        type="text"
                        onClick={() => {
                          setSearchParam({ search: item.query, target: item.target });
                          setQuickFilters(item.filters);
                          performSearch(item.query, item.target, true);
                          setShowAdvancedFilters(false);
                        }}
                        className="saved-name"
                      >
                        {item.name}
                      </Button>
                      <Button
                        type="text"
                        size="small"
                        danger
                        onClick={() => {
                          setSavedSearches(savedSearches.filter(s => s.id !== item.id));
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                    <div className="saved-meta">
                      <span className="saved-query">{item.query}</span>
                      <Tag size="small">{item.target}</Tag>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Advanced Filter Options */}
          <div className="filter-section">
            <h4 className="section-title">
              <SettingOutlined /> Filter Options
            </h4>
            
            <div className="filter-group">
              <label className="filter-label">Status Filter</label>
              <Select
                value={quickFilters.status}
                onChange={(value) => applyQuickFilter('status', value)}
                style={{ width: '100%' }}
                options={[
                  { label: 'All Status', value: 'all' },
                  { label: 'Active', value: 'active' },
                  { label: 'Inactive', value: 'inactive' },
                  { label: 'Pending', value: 'pending' },
                  { label: 'Suspended', value: 'suspended' }
                ]}
              />
            </div>

            <div className="filter-group">
              <label className="filter-label">Date Range</label>
              <DatePicker.RangePicker
                value={quickFilters.dateRange}
                onChange={(dates) => applyQuickFilter('dateRange', dates)}
                style={{ width: '100%' }}
              />
            </div>

            <div className="filter-group">
              <label className="filter-label">Sort By</label>
              <Select
                value={quickFilters.sortBy}
                onChange={(value) => applyQuickFilter('sortBy', value)}
                style={{ width: '100%', marginBottom: 8 }}
                options={[
                  { label: 'Relevance', value: 'relevance' },
                  { label: 'Date Created', value: 'date' },
                  { label: 'Name', value: 'name' },
                  { label: 'Status', value: 'status' },
                  { label: 'Last Modified', value: 'modified' }
                ]}
              />
              <Select
                value={quickFilters.sortOrder}
                onChange={(value) => applyQuickFilter('sortOrder', value)}
                style={{ width: '100%' }}
                options={[
                  { label: 'Descending', value: 'desc' },
                  { label: 'Ascending', value: 'asc' }
                ]}
              />
            </div>

            <div className="filter-actions">
              <Button
                type="primary"
                block
                onClick={() => {
                  if (searchParam?.search) {
                    performSearch(searchParam.search, searchParam.target, true);
                  }
                  setShowAdvancedFilters(false);
                }}
              >
                Apply Filters
              </Button>
              <Button
                type="default"
                block
                onClick={() => {
                  setQuickFilters({
                    status: 'all',
                    dateRange: null,
                    sortBy: 'relevance',
                    sortOrder: 'desc'
                  });
                }}
                style={{ marginTop: 8 }}
              >
                Reset Filters
              </Button>
            </div>
          </div>
        </div>
      </Drawer>

      <FacilitiesExportModal
        open={facilityExportOpen}
        onClose={() => setFacilityExportOpen(false)}
        search={searchParam?.search ?? ""}
        estimatedRows={facilityExportRowEstimate}
        onViewExports={() => {
          setFacilityExportOpen(false);
          setFacilityExportsDrawerOpen(true);
        }}
      />

      <FacilitiesExportsDrawer
        open={facilityExportsDrawerOpen}
        onClose={() => setFacilityExportsDrawerOpen(false)}
      />

    </div>
  );
};


export default SearchHook;